module.exports = __webpack_public_path__ + "static/media/tada_driver_privacy_kh_KH.80ff39aa.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_driver_privacy_kh_KH.md
// module id = 78
// module chunks = 0